// Campus photo for /colleges/depaul-university: CC0 1.0, by Just, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AOn_the_Lincoln_Park_Campus_of_DePaul_University_in_Chicago.JPG), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/depaul-university/; credited under the photo.
const photo = {
    "slug": "depaul-university",
    "alt": "A tree-lined lawn between brick academic buildings on DePaul University's Lincoln Park Campus in Chicago",
    "src": "/colleges/depaul-university/campus-1600.webp",
    "srcSmall": "/colleges/depaul-university/campus-800.webp",
    "srcMid": "/colleges/depaul-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/depaul-university/og.jpg",
    "title": "On the Lincoln Park Campus of DePaul University in Chicago",
    "author": "Just",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AOn_the_Lincoln_Park_Campus_of_DePaul_University_in_Chicago.JPG",
    "read": "2026-10-02"
};

export default photo;
